// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBadge_badge__gircz","SMALL":"NotificationBadge_SMALL__eDaG+","MEDIUM":"NotificationBadge_MEDIUM__YFE3r","empty":"NotificationBadge_empty__LbM2+"};